/* @generated */
import { assignInlineVars } from "@vanilla-extract/dynamic";
import { getKeys } from "./utils.esm.js";
const BREAKPOINT_ORDER = ["xsmall", "small", "medium", "large", "xlarge"];
function walkByBreakpoint(propertyByBreakpoints, defaultValue) {
  const walkedProperty = {};
  BREAKPOINT_ORDER.forEach((breakpoint, index) => {
    const previousBreakpoint = index === 0 ? defaultValue : walkedProperty[BREAKPOINT_ORDER[index - 1]];
    walkedProperty[breakpoint] = propertyByBreakpoints[breakpoint] || previousBreakpoint;
  });
  return walkedProperty;
}
const ALIGN_X_TO_FLEX_ALIGN = {
  left: "flex-start",
  center: "center",
  right: "flex-end",
  between: "space-between"
};
const ALIGN_Y_TO_FLEX_ALIGN = {
  top: "flex-start",
  center: "center",
  bottom: "flex-end"
};
const alignToFlexAlign = {
  start: "flex-start",
  center: "center",
  end: "flex-end",
  stretch: "stretch"
};
const justifyToFlexJustify = {
  start: "flex-start",
  center: "center",
  end: "flex-end",
  between: "space-between",
  evenly: "space-evenly"
};
function getResponsiveStyling({
  styleProps,
  varMap,
  sizeToStylingMapping
}) {
  let retValue = ["", {}];
  if (!styleProps) {
    return retValue;
  }
  if (typeof styleProps === "string") {
    const [className, cssVar] = sizeToStylingMapping["xsmall"];
    const stylePropValue = styleProps in varMap ? varMap[styleProps] : styleProps;
    return [className, assignInlineVars({ [cssVar]: stylePropValue })];
  }
  for (const size of getKeys(styleProps)) {
    const mappedStyles = sizeToStylingMapping[size];
    let stylePropValue = styleProps[size];
    if (!mappedStyles || !stylePropValue) {
      continue;
    }
    const [prevClass, prevVars] = retValue;
    const [className, cssVar] = mappedStyles;
    stylePropValue = stylePropValue in varMap ? varMap[stylePropValue] : stylePropValue;
    const vars = assignInlineVars({ [cssVar]: stylePropValue });
    const joinedClassNames = [prevClass, className].join(" ");
    const mergedInlineVars = {
      ...prevVars,
      ...vars
    };
    retValue = [joinedClassNames, mergedInlineVars];
  }
  return retValue;
}
export {
  ALIGN_X_TO_FLEX_ALIGN,
  ALIGN_Y_TO_FLEX_ALIGN,
  BREAKPOINT_ORDER,
  alignToFlexAlign,
  getResponsiveStyling,
  justifyToFlexJustify,
  walkByBreakpoint
};
